import { Components } from "@mui/material/styles";
import { themeShadows } from "src/theme-mui/tokens/shadows";

export const linkColorVariants = {
    green: {
        default: "var(--mui-palette-green-600)",
        hover: "var(--mui-palette-green-400)",
        active: "var(--mui-palette-green-800)",
    },
    blue: {
        default: "var(--mui-palette-blue-700)",
        hover: "var(--mui-palette-blue-400)",
        active: "var(--mui-palette-blue-800)",
    },
    gray: {
        default: "var(--mui-palette-gray-800)",
        hover: "var(--mui-palette-gray-600)",
        active: "var(--mui-palette-gray-900)",
    },
    disabled: "var(--mui-palette-gray-500)",
} as const;

const getVariantColors = (color: string | undefined) => {
    if (color?.startsWith("green")) {
        return linkColorVariants.green;
    }
    if (color?.startsWith("blue")) {
        return linkColorVariants.blue;
    }
    return linkColorVariants.gray;
};

export const MuiLink: Components["MuiLink"] = {
    defaultProps: {
        color: "inherit",
        fontSize: "sm",
    },
    styleOverrides: {
        root: ({ ownerState }) => {
            const variant = getVariantColors(ownerState.color);

            return {
                transition: "color 0.2s ease, text-decoration 0.2s ease",
                fontWeight: "bold",
                textUnderlineOffset: "0.24em",
                color: variant.default,

                "&.MuiLink-underlineAlways": {
                    textDecorationColor: variant.default,
                    color: variant.default,
                },

                "&:hover": {
                    color: variant.default,
                    "&.MuiLink-underlineAlways": {
                        color: variant.hover,
                        textDecorationColor: variant.hover,
                    },
                },

                "&:active": {
                    color: variant.active,
                },

                "&.Mui-disabled": {
                    color: linkColorVariants.disabled,
                    pointerEvents: "none",
                    cursor: "default",
                    textDecoration: "none",
                },

                "&.Mui-focusVisible": {
                    outline: "none",
                    outlineOffset: "2px",
                    boxShadow: themeShadows.focusVisible,
                },
            };
        },
    },
    variants: [
        {
            props: { variant: "unstyled" },
            style: {
                color: "inherit",
                cursor: "pointer",
                fontWeight: "normal",
                textDecoration: "none",
                "&:hover": {
                    color: "inherit",
                    textDecoration: "none",
                },
            },
        },
    ],
};
